import http from '../common/compornents/httpcommon';

class TokuisakiServ {
  getTokuisaki = (params: any) => {
    return http.get('getTokuisakiName/', { params });
  };
  getKsKyotenData = () => {
    return http.get('getKsKyotenData/');
  };
  getTokuisakiData = (params: any) => {
    return http.get('getTokuisakiData/', { params });
  };
}
export default new TokuisakiServ();
